import type { Feature } from '@backend/lib-feature-mgr';
import type { BusinessUnit } from '@backend/lib-l10n';

import { useBusinessUnitContext } from '~/contexts/BusinessUnitContext/BusinessUnitContext';

export function useCheckFeatureEnabled(feature: Feature<BusinessUnit>): boolean {
  const { businessUnit } = useBusinessUnitContext();

  return feature.isEnabled(businessUnit);
}
